import { __assign, __extends } from "tslib";
import React from 'react';
export function withDimensions(ExternalComponent) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(WithDimensions, _super);
            function WithDimensions(props) {
                var _this = _super.call(this, props) || this;
                _this.updateWidth = function () {
                    if (_this.width !== _this.state.width) {
                        _this.setState({
                            width: _this.width,
                        });
                    }
                };
                _this.state = {
                    width: 0,
                };
                return _this;
            }
            Object.defineProperty(WithDimensions.prototype, "width", {
                get: function () {
                    return this.container ? this.container.clientWidth : 0;
                },
                enumerable: false,
                configurable: true
            });
            WithDimensions.prototype.componentDidMount = function () {
                this.delayedUpdateWidth();
            };
            WithDimensions.prototype.UNSAFE_componentWillReceiveProps = function () {
                this.delayedUpdateWidth();
            };
            WithDimensions.prototype.componentWillUnmount = function () {
                this.clearDelayedUpdateWidth();
            };
            WithDimensions.prototype.delayedUpdateWidth = function () {
                this.delayedUptadeTimeout = requestAnimationFrame(this.updateWidth);
            };
            WithDimensions.prototype.clearDelayedUpdateWidth = function () {
                cancelAnimationFrame(this.delayedUptadeTimeout);
            };
            WithDimensions.prototype.render = function () {
                var _this = this;
                return (React.createElement("div", { style: { width: '100%' }, ref: function (container) { return (_this.container = container); } },
                    React.createElement(ExternalComponent, __assign({}, this.props, { width: this.state.width }))));
            };
            return WithDimensions;
        }(React.Component)),
        _a.sizeClassName = ExternalComponent.sizeClassName,
        _a.alignmentClassName = ExternalComponent.alignmentClassName,
        _a.textWrapClassName = ExternalComponent.textWrapClassName,
        _a;
}
//# sourceMappingURL=withDimensions.js.map